import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder } from "@angular/forms";

import { MatTabChangeEvent } from "@angular/material/tabs";

import { select, Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { AppState, loadedTenantState } from "src/app/store/reducers";

import { TranslateService } from "@ngx-translate/core";
import { SnackbarService } from "../../services/snackbar/snackbar.service";

import { BaseDatepicker, DATEPICKER_FORM } from "../../base-classes/base-datepicker/base-datepicker";
import { MatSelectChange } from "@angular/material/select";

@Component({
  selector: "app-tab-datepicker",
  templateUrl: "./tab-datepicker.component.html",
  styleUrls: ["./tab-datepicker.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class TabDatepickerComponent
  extends BaseDatepicker
  implements OnInit, OnDestroy
{
  dateTimeFormat: string;
  tenantData$: Observable<any>;

  tenantDataSub: Subscription;

  dateModes = [
    {
      id: "MONTH",
      name: "Dates.monthRange",
      icon: "calendar_month",
    },
    {
      id: "WEEK",
      name: "Dates.weekRange",
      icon: "date_range",
    },
    {
      id: "YESTERDAY",
      name: "Dates.yesterdayRange",
      icon: "today",
    },
    {
      id: "TODAY",
      name: "Dates.dayRange",
      icon: "calendar_today",
    },
    {
      id: "CUSTOM",
      name: "Dates.customRange",
      icon: "edit_calendar"
    },
  ];
  
  constructor(
    public store: Store<AppState>,
    public fb: FormBuilder,
    public translate: TranslateService,
    public snackbarService: SnackbarService
  ) {
    super(store, fb, translate, snackbarService);
  }

  ngOnInit(): void {
    this.tenantData$ = this.store.pipe(select(loadedTenantState));

    this.dateMode.setValue(this.selectedMode);

    this.loadTenantDateTimeFomat();
    this.createDatePickerForm();
    this.loadDatePicker();

    if (this.selectedMode === "CUSTOM") {
      this.datepickerFormGroup.controls.startDate.setValue(localStorage.getItem("dashboardStartDate") ? localStorage.getItem("dashboardStartDate") : null);
      this.datepickerFormGroup.controls.endDate.setValue(localStorage.getItem("dashboardEndDate") ? localStorage.getItem("dashboardEndDate") : null);
    }
  }

  loadTenantDateTimeFomat() {
    this.tenantDataSub = this.tenantData$.subscribe((data: any) => {
      if (data) {
        this.dateTimeFormat = data.datetimeFormat;
      }
    });
  }

  setSelectedDateMode(event: MatSelectChange) {
    this.selectedMode = event.value;

    this.datepickerFormGroup.get(DATEPICKER_FORM.modes).setValue(this.selectedMode);
    this.calculateDate(this.selectedMode);
  }

  getSelectedName(id: string): string {
    const selected = this.dateModes.find(mode => mode.id === id);
    return selected ? selected.name : '';
  }

  getSelectedIcon(id: string): string {
    const selected = this.dateModes.find(mode => mode.id === id);
    return selected ? selected.icon : '';
  }

  ngOnDestroy(): void {
    if (this.tenantDataSub) {
      this.tenantDataSub.unsubscribe();
    }
  }
}
